export const filePreviewCache = {
  lifetimeMs: 60_000,
  maximumEntries: 32
} as const;

export const previewableImageContentTypes: ReadonlySet<string> = new Set([
  'image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/avif', 'image/bmp'
]);
